import type { RouteItem } from '@/types/routes';
import type { AppRoutes } from '@consts/routes';

export const routeActive = (route: RouteItem) => {
    return location.pathname === route.link || (route.extraActive && route.extraActive.includes(location.pathname as AppRoutes));
};

export const hasActiveRoute = (routes: RouteItem[]) => {
    return routes.some((route) => routeActive(route));
};
